import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectMarketerContractPdf: "selectMarketerContractPdf [Action]",
  selectMarketerContractPdfLoading: "selectMarketerContractPdfLoading [Action]",
  selectMarketerContractPdfAsync: "selectMarketerContractPdfAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_marketer_contract_pdf = (
  state = inistiaState,
  action = {}
) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.selectMarketerContractPdf:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };

    case actionTypes.selectMarketerContractPdfLoading:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectMarketerContractPdfLoading,
    payload: payload,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "select_marketer_contract_pdf",
    data: payload ? payload : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectMarketerContractPdf,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectMarketerContractPdfLoading,
      payload: false,
    });
  }
}

export function* selectMarketerContractPdf() {
  yield takeLatest(actionTypes.selectMarketerContractPdfAsync, handleWorker);
}
